// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"da2df1d8","455":"82d539ca","977":"2c80204f"}[chunkId] + ".chunk.js";
};